// tslint:disable: max-line-length triple-equals
import React, { useEffect, useState } from 'react';
import './styles.scss';
import { getItem, removeItem, setItem } from '../../utils/localStorage';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  deleteSelfAssessment,
  getSelfAssessment,
  selfAssessmentsListForUser,
} from './apiCaller';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { getDepartmentApi } from '../../components/SelfAssessmentAssignDepartment/apiCaller';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import '../../style/main.scss';
import { convertUTCDateDisplay } from '../../helpers/dates';
import moment from 'moment';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getUsers } from './../../requests/users';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Event } from '../../enums/labels/Event';
import { convertName } from '../../helpers/convertName';
import { isUnauthorized } from '../../utils/common';
import { getTemplateData } from '../../requests/login';
import { filterTemplateData } from '../../helpers/filterData';
import { getSubCategoryList } from '../../helpers/getSubCategoryList';
import { Button } from '../../app/common/sharedComponents/Button';
import { useTranslation } from 'react-i18next';
import {
  ActionButtonContainer,
  BottomSheetButtonSpacing,
  ContentArea,
  DepartmentHeaderContainer,
  FilterContainer,
  FilterModalContent,
  FilterModalHeaderContainer,
  HeaderContainer,
  NoDataMessageContainer,
  NoResultContainer,
  NoResults,
  SelfAssessmentsContainer,
  CreateNewMyAuditButtonContainer,
  StatusRadioReceivedWrapper,
  StatusRadioCreatedByWrapper,
  StatusRadioAssessedWrapper,
  IconContainer,
  FilterInputContainer,
  SearchFieldInput,
  DisabledSearchBoxContainer,
  SelfAssessmentDatePickerContainer,
  InputContainer,
  CalendarIconContainer,
  FilterStatusContainer,
  SortContainer,
  CardContentWrapper,
  DepartmentContainer,
  LoaderContainer,
  FilterLabelContainer,
} from './styled.SelfAssessment';
import {
  Body3,
  Body4,
  Body5,
  Headline3,
  Headline5,
} from '../../app/common/typography';
import { SearchFile } from '../../app/common/icons/SearchFile';
import { Modal } from '../../app/common/sharedComponents/Modal';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import {
  ModalHeader,
  ModalContent,
} from '../../app/common/sharedStyledComponents/Modal.styled';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { DropdownSingle } from '../../app/common/sharedComponents/DropdownSingle';
import { BottomSheet } from '../../app/common/sharedComponents/BottomSheet';
import { IconButton } from '../../app/common/sharedComponents/IconButton';
import { FilterIcon } from '../../app/common/icons/FilterIcon';
import {
  getBrandAndHotelData,
  userHotelDetails,
} from '../../helpers/handleBrandAndHotelData';
import {
  getInitialHotelSelectionData,
  updateHotelSelection,
} from '../../helpers/hotelSelectorHelpers';
import { SwitchHotelModal } from '../../app/common/sharedComponents/SwitchHotelModal';
import { SetDefaultTemplateId } from '../commons/Header/SetDefaultTemplateId';
import { INotificationHotelData } from '../../app/@types/switchHotelModal';
import { IListSelector } from '../../app/@types/subHeaderSelector';
import { LineHeader } from '../../app/pages/MyAudit/MyAuditChecklist/MyAuditChecklist.styled';
import { SubHeaderSelector } from '../../app/common/sharedComponents/SubHeaderSelector';
import { SearchIcon } from '../../app/common/icons/SearchIcon';
import { SearchBoxContainsUsers } from './SearchBoxContainsUsers';
import { CloseCircleRed } from '../../app/common/icons/CloseCircleRed';
import { Calendar } from '../../app/common/icons/Calendar';
import { IDropdownOption } from 'src/app/@types/dropdown';
import { Sort } from '../../app/common/sharedComponents/Sort';
import { Filter } from '../../app/@types/sort';
import { ExpandableCard } from '../../app/myAudit/components/ExpandableCard';
import { SelfAssessmentListSkeleton } from '../../app/common/sharedComponents/SelfAssessmentListSkeleton';
import { sentryReport } from '../../helpers/sentry';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { RadioButton } from '../../app/common/sharedComponents/RadioButton';
import { UserTypeEnum } from '../../app/common/enum/generic';

const RadioTypesToFilter = {
  received: 'Received By: ',
  sent: 'Created By: ',
};

const SelfAssessments = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const isOverDue = params.OverDue === 'true';
  const selectedAssessmentId = params.assessmentId;
  const evnt = params.evnt;
  const percentageCompleted =
    getItem('percentageCompleted') &&
    getItem('percentageCompleted').percentageCompleted;
  const percentageCompletedId =
    getItem('percentageCompleted') && getItem('percentageCompleted').perComId;
  const filterInitialisation = getItem('saFilter') && getItem('saFilter');
  const userData = getItem('user');
  const isViewer =
    userData && userData.user && userData.user.userType === UserTypeEnum.noData;
  const [template, setTemplate] = useState([]);
  const [assessment, setAssessment] = useState<any>([]);
  const [currentlySortedState, setCurrentlySortedState] = useState<string>(
    '-stayEnd'
  );
  const [categoriesData, setCategoriesData] = useState<any>([]);
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [assignees, setAssignees] = useState<
    | [
      {
        id: number;
        text: string;
      }
    ]
    | []
  >(filterInitialisation ? filterInitialisation.assignees : []);
  const [selfAssessments, setSelfAssessments] = useState<any>([]);
  const [itemToDelete, setItemToDelete] = useState(undefined);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [text, setText] = useState('');
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [applyFilter, setApplyFilter] = useState(false);
  const [focusAreaOptions, setFocusAreaOptions] = useState<any>([]);
  const [textName, setTextName] = useState('');
  const [users, setAssigneeUsers] = useState<any>(undefined);
  const [radioCheck, setRadioCheck] = useState(
    filterInitialisation ? filterInitialisation.radioCheck : evnt
  );
  const [startDate, setStartDate] = useState<Date | undefined>(
    filterInitialisation &&
    filterInitialisation.startDate &&
    new Date(filterInitialisation.startDate)
  );
  const [endDate, setEndDate] = useState<Date | undefined>(
    filterInitialisation &&
    filterInitialisation.endDate &&
    new Date(filterInitialisation.endDate)
  );
  const [selfAssessmentStatus, setSelfAssessmentStatus] = useState(
    isOverDue
      ? 'overdue'
      : filterInitialisation
        ? filterInitialisation.selfAssessmentStatus
        : ''
  );
  const [selectedFocusArea, setSelectedFocusArea] = useState<
    string | undefined
  >(filterInitialisation && filterInitialisation.selectedFocusArea);
  const [assessedTag, setAssessedTag] = useState(
    filterInitialisation ? filterInitialisation.assessedTag : false
  );
  const [hasMore, setHasMore] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const hasHotelSelector = localStorage.getItem('hotelSelectorDropdown');
  const [listSelector, setListSelector] = useState<IListSelector[]>([]);
  const [valueHeaderSelector, setValueHeaderSelector] = useState<string>();
  const [titleHeaderSelector, setTitleHeaderSelector] = useState<string>();
  const [selectedSelfAssessmentId, setSelectedSelfAssessmentId] = useState(
    selectedAssessmentId === 'all' ? undefined : selectedAssessmentId
  );
  const [andOrOption, setAndOrOption] = useState<'and' | 'or'>(
    filterInitialisation && filterInitialisation.andOr
      ? filterInitialisation.andOr
      : 'and'
  );

  const [prevRadio, setPrevRadio] = useState(evnt);
  const [userTextName, setUserTextName] = useState('');
  const [usersData, setUsersData] = useState<any>(undefined);
  const [sortingState, setSortingState] = useState<Filter[]>();
  const [user, setUser] = React.useState<any>(
    filterInitialisation
      ? filterInitialisation.user
      : {
        id: userData.user.id,
        text: `${userData.user.userFirstName} ${userData.user.userLastName}`,
      }
  );
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [openedCardIndex, setOpenedCardIndex] = useState(null);
  const [appliedFilterCount, setAppliedFilterCount] = useState<number>(0);

  const accordionColumns = (selfAssessment) => [
    prevRadio && prevRadio === Event.sent
      ? selfAssessment.hasChild
        ? 'Multiple'
        : `${convertName(selfAssessment.auditor.userLastName)}, ${convertName(
          selfAssessment.auditor.userFirstName
        )}`
      : `${convertName(selfAssessment.creator.userLastName)}, ${convertName(
        selfAssessment.creator.userFirstName
      )}`,
    percentageCompleted && selfAssessment.id === percentageCompletedId
      ? percentageCompleted + '%'
      : `${selfAssessment.percentageCompleted || 0}%`,
    '',
    moment(convertUTCDateDisplay(selfAssessment.stayEnd)).format('DD/MM/YY'),
  ];

  const [searchParams] = useSearchParams();
  const hotelId = parseInt(searchParams.get('hotelId') as string);
  const hasHotelId: boolean = !!hotelId;
  const { selectedHotel } = userHotelDetails();
  const allHotels = getBrandAndHotelData();
  const [showSwitchHotelModal, setShowSwitchHotelModal] = useState<boolean>(
    hasHotelId && hotelId !== selectedHotel
  );
  const [
    notificationHotelData,
    setNotificationHotelData,
  ] = useState<INotificationHotelData>();
  const type = 'selfAssessment';

  useEffect(() => {
    if (hotelId) {
      const SwitchHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === hotelId
      );
      const CurrentHotelDetail = allHotels.find(
        (hotel) => parseInt(hotel.id) === parseInt(selectedHotel)
      );
      setNotificationHotelData({
        switchHotel: SwitchHotelDetail.name,
        currentHotel: CurrentHotelDetail.name,
        hotelId,
        type,
      });
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (
      focusAreaOptions &&
      focusAreaOptions.categories &&
      focusAreaOptions.categories.length &&
      !showSwitchHotelModal
    ) {
      updateFilterCounter();
      let assigneesList: number[] = [];
      if (assignees.length) {
        assigneesList = assignees.map((assignee) => assignee.id);
      }
      const payLoad = {
        containUser: assigneesList,
        radioCheck,
        assessedTag,
        selfAssessmentStatus,
        sort: currentlySortedState,
        startDate,
        endDate,
        selectedFocusArea: selectedFocusArea
          ? getSubCategoryList(parseInt(selectedFocusArea), focusAreaOptions)
          : undefined,
        pageNumber,
        selectedSelfAssessmentId,
        andOr: andOrOption === 'and',
        userId: [user.id],
      };
      selfAssessmentsListForUser(payLoad)
        .then((res) => {
          setSelfAssessments(res.results.length > 0 ? res.results : []);
          setItem('saFilter', {
            user,
            assignees,
            startDate,
            endDate,
            selfAssessmentStatus,
            selectedFocusArea,
            radioCheck,
            assessedTag,
            andOr: andOrOption,
          });
          if (res.numberOfPages <= pageNumber) {
            setHasMore(false);
          } else {
            setHasMore(true);
            setPageNumber(pageNumber + 1);
          }
          setIsLoading(false);
        })
        .catch((res) => {
          showErrorMessage('Unable to get list', !isUnauthorized(res));
        });
    }
  }, [applyFilter, listSelector]);

  const fetchData = () => {
    setIsLoading(true);
    let assigneesList: number[] = [];
    if (assignees.length) {
      assigneesList = assignees.map((assignee) => assignee.id);
    }
    const payLoad = {
      containUser: assigneesList,
      radioCheck,
      assessedTag,
      sort: currentlySortedState,
      selfAssessmentStatus,
      startDate,
      endDate,
      selectedFocusArea: selectedFocusArea
        ? getSubCategoryList(parseInt(selectedFocusArea), focusAreaOptions)
        : undefined,
      pageNumber,
      selectedSelfAssessmentId,
      andOr: andOrOption === 'and',
      userId: [user.id],
    };
    selfAssessmentsListForUser(payLoad)
      .then((res) => {
        if (pageNumber === 1) {
          setSelfAssessments(res.results);
        } else {
          setSelfAssessments([...selfAssessments, ...res.results]);
        }
        if (res.numberOfPages <= pageNumber) {
          setHasMore(false);
        } else {
          setHasMore(true);
          setPageNumber(pageNumber + 1);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage('Unable to get list', !isUnauthorized(error));
      });
  };

  function handleContainsUsersSearchValue (selectedOptions) {
    setAndOrOption(selectedOptions.logic || 'and');
    setAssignees(selectedOptions.list);
  }

  useEffect(() => {
    setSelfAssessments([]);
    fetchData();
  }, [currentlySortedState]);

  useEffect(() => {
    if (!selectedSelfAssessmentId) {
      return;
    }
    const assess =
      selfAssessments &&
      selfAssessments.find(
        (selfAssessment) => selfAssessment.id === selectedSelfAssessmentId
      );
    handleCollapsible(assess);
  }, [selectedSelfAssessmentId]);

  useEffect(() => {
    const allHotels = getBrandAndHotelData();
    const { hotelName, brandName, hotelsWithSelection } =
      getInitialHotelSelectionData(allHotels);

    setListSelector(hotelsWithSelection);
    setTitleHeaderSelector(brandName);
    setValueHeaderSelector(hotelName);
  }, []);

  useEffect(() => {
    const sortingData: Filter[] = [
      {
        label:
          prevRadio === Event.sent
            ? t('COMMON.MY_AUDIT.SUMMARY_CARD.SENT_TO')
            : t('COMMON.MY_AUDIT.SUMMARY_CARD.SENT_BY'),
        field: 'creator.userFirstName,creator.userLastName',
        sortingDirection: '',
        id: 1,
        callback: sortingCallback,
      },
      {
        label: t('COMMON.MY_AUDIT.SUMMARY_CARD.COMPLETE'),
        field: 'percentageCompleted',
        sortingDirection: '',
        id: 2,
        callback: sortingCallback,
      },
      {
        label: t('COMMON.MY_AUDIT.SUMMARY_CARD.DUE_DATE'),
        field: 'stayEnd',
        sortingDirection: 'desc',
        id: 3,
        callback: sortingCallback,
      },
    ];
    setSortingState(sortingData);
  }, []);

  function sortingCallback (id: number | string, filters?: Filter[]) {
    const updatedFilters: Filter[] = [];
    let sortField = '';
    let sortDirection = '';

    if (filters) {
      setPageNumber(1);
      filters.forEach((filter) => {
        if (filter.id === id) {
          filter.sortingDirection =
            filter.sortingDirection === 'asc' ? 'desc' : 'asc';
          sortField = filter.field;
          sortDirection = filter.sortingDirection === 'asc' ? '' : '-';
        } else {
          filter.sortingDirection = '';
        }
        updatedFilters.push(filter);
      });
      setSortingState(updatedFilters);
      setCurrentlySortedState(`${sortDirection}${sortField}`);
    }
  }

  function clickSelectSection (
    id: string | number,
    clientId: string | number,
    brandId: string | number
  ) {
    const { updatedHotelList, selectedHotel } = updateHotelSelection(
      listSelector,
      id,
      clientId,
      brandId
    );

    if (selectedHotel) {
      setSelfAssessments([]);
      setPageNumber(1);
      setTitleHeaderSelector(selectedHotel.brandName);
      setValueHeaderSelector(selectedHotel.name);
    }

    setListSelector(updatedHotelList);
  }

  function updateFilterCounter () {
    let count = 0;
    if (assignees.length > 0) {
      count++;
    }
    if (startDate) {
      count++;
    }
    if (selectedFocusArea) {
      count++;
    }
    if (selfAssessmentStatus) {
      count++;
    }
    setAppliedFilterCount(count);
  }

  const clear = () => {
    updateFilterCounter();
    setAssignees([]);
    setAndOrOption('and');
    setSelectedFocusArea(undefined);
    setEndDate(undefined);
    setStartDate(undefined);
    setSelfAssessmentStatus('');
    setClearFilter(!clearFilter);
    setPageNumber(1);
    setShowFilterModal(false);
    setRadioCheck(
      filterInitialisation ? filterInitialisation.radioCheck : evnt
    );
    setUser({
      id: userData.user.id,
      text: `${userData.user.userFirstName} ${userData.user.userLastName}`,
    });
    setApplyFilter(!applyFilter);
    setSelfAssessments([]);
  };

  useEffect(() => {
    getUsers(textName).then((response) => {
      setAssigneeUsers(response);
    });
  }, [textName]);

  useEffect(() => {
    getUsers(userTextName).then((response) => {
      setUsersData(response);
    });
  }, [userTextName]);

  useEffect(() => {
    if (!showSwitchHotelModal) {
      getDepartmentApi()
        .then((resp) => {
          delete resp.data;
          setFocusAreaOptions({ categories: Object.values(resp) });
        })
        .catch((err) =>
          showErrorMessage(
            'Could Load Departments for Filters',
            !isUnauthorized(err)
          )
        );
    }
  }, [showSwitchHotelModal]);

  const statusOptions: IDropdownOption[] = [
    {
      value: 'overdue',
      label: t('COMMON.MY_AUDIT.STATUSES.OVERDUE'),
    },
    {
      value: 'ongoing',
      label: t('COMMON.MY_AUDIT.STATUSES.ONGOING'),
    },
    {
      value: 'completed',
      label: t('COMMON.MY_AUDIT.STATUSES.COMPLETED'),
    },
  ];

  const getSelectedSelfAssessmentStatus = (selfAssessmentStatus) => {
    return statusOptions.find(
      (option) => option.value === selfAssessmentStatus
    );
  };

  const viewSelfAssessment = (categoriesData, assessmentData) => {
    navigate('/viewSelfAssessment', {
      state: {
        categoriesData,
        assessmentData,
        assessment,
        evnt,
        isListScreen: true,
        isSendScreen: false,
        templateId: assessment.template.id,
      },
    });
  };

  const handleDeleteSelfAssessment = async () => {
    await handleDelete(itemToDelete);
    setShowDeleteModal(false);
    navigate('/myactions');
  };

  const selfAssessmentSummary = (
    assessmentDate,
    assessmentId,
    isSummary,
    evnt,
    template,
    selfStayStart
  ) => {
    setItem('selfAssessment', assessmentId);
    navigate('/selfAssessmentSummary', {
      state: {

        assessmentDate,
        assessmentId,
        isSummary,
        duplicateCategories: assessment.duplicateCategories,
        evnt,
        passsTemplate: filterTemplateData(template),
        selfAssessmentData: assessment,
        selfStayStart,
        taggedUsers: assessment.duplicateCategoryAssessed ? assessment.duplicateCategoryAssessed : [],
      },
    });
  };

  const handleDelete = (iToD) => {
    deleteSelfAssessment(iToD)
      .then((resp) => {
        if (resp) {
          showSuccessMessage('Self Assessment Deleted Successfully');
        }
      })
      .catch((err) => {
        showErrorMessage('Unable to delete Self Assessment');
      });
  };

  const handleGetCategoriesData = async (assessmentData) => {
    const saTemplateId = assessmentData.template.id;
    const templateData: any = await getTemplateData(saTemplateId, userData);
    const cloneTemplateData: any = { ...templateData };
    setAssessment(assessmentData);

    if (templateData) {
      const duplicateCategories = assessmentData.duplicateCategories.map(
        (duplicateCategory) => duplicateCategory.templateCategoryId
      );
      let categories = templateData.category.filter(
        (category) => category.categoryType === 'category'
      );
      const subCategories = templateData.category.filter(
        (subCategory) =>
          subCategory.categoryType === 'subCategory' &&
          duplicateCategories.includes(subCategory.id)
      );
      const superCategories = templateData.category.filter(
        (superCategory) => superCategory.categoryType === 'superCategory'
      );
      categories = categories
        .map((category) => {
          const childs = subCategories.filter((subCategory) =>
            category.categories.includes(subCategory.uuid)
          );
          const parent = superCategories.filter((superCategory) =>
            superCategory.categories.includes(category.uuid)
          );
          if (childs.length > 0) {
            return {
              ...category,
              subCategories: childs,
              superCategories: parent,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      cloneTemplateData.category = [
        ...categories,
        ...subCategories,
        ...superCategories,
      ];
      setCategoriesData(categories);
      setTemplate(cloneTemplateData);
    }
  };

  const handleCollapsible = async (assessment) => {
    setLoadingIndex(assessment.id);
    setOpenedCardIndex(assessment.id);
    setCategoriesData([]);
    try {
      const assessmentData = await getSelfAssessment(
        assessment.isAuditor && assessment.childId
          ? assessment.childId
          : assessment.id
      );
      if (assessmentData) {
        await handleGetCategoriesData(assessmentData);
        setLoadingIndex(null);
      }
    } catch (err: any) {
      sentryReport(err.response.data, err.message, err.code, {
        summaryError: t(
          'COMMON.ALERT_MESSAGES.UNABLE_TO_GET_SELF_ASSESSMENT_DATA'
        ),
        path: '/selfAssessments/:evnt/:OverDue/:assessmentId',
      });
    }
  };

  async function switchHotelHandler (hotelId) {
    const hotelDetails = allHotels.find(
      (hotel) => parseInt(hotel.id) === parseInt(hotelId)
    );
    const selectedBrand = hotelDetails.brandId;
    setItem('selectedBrand', selectedBrand);
    setItem('selectedClient', hotelDetails.clientId);
    setItem('selectedHotel', hotelDetails.id);
    await SetDefaultTemplateId(hotelDetails.id);
    setShowSwitchHotelModal(false);
  }

  const formatCategories = (categoriesData) => {
    return categoriesData.map((category) => category.value).join(', ');
  };

  return (
    <>
      <HeaderContainer>
        <AppHeader title={t('COMMON.SELF_ASSESSMENT.TITLES.SELF_ASSESSMENT')} navigateTo="/myActions" />
        {!hasHotelSelector && (
          <>
            <LineHeader />
            <SubHeaderSelector
              title={titleHeaderSelector}
              subTitle={valueHeaderSelector}
              listSelector={listSelector}
              clickSelectSection={clickSelectSection}
            />
          </>
        )}
      </HeaderContainer>
      <SelfAssessmentsContainer>
        <DepartmentHeaderContainer>
          {user && (
            <Headline3>
              {prevRadio === Event.received && RadioTypesToFilter.received}
              {prevRadio === Event.sent && RadioTypesToFilter.sent}
              {prevRadio !== Event.received &&
                prevRadio !== Event.sent &&
                'Tagged: '}
              {convertName(user.text)}
            </Headline3>
          )}

          <FilterContainer>
            <IconButton
              title={`${t('COMMON.MY_AUDIT.BUTTON.FILTER')} ${appliedFilterCount > 0 ? ` (${appliedFilterCount})` : ''
                }`}
              onClick={() => setShowFilterModal(true)}
              rightIcon={<FilterIcon />}
            />
          </FilterContainer>
        </DepartmentHeaderContainer>
        {!isLoading && selfAssessments.length === 0 && (
          <>
            <NoResultContainer>
              <NoResults />
              <SearchFile />
              <Body3 color="eerieBlack">
                {t('COMMON.SELF_ASSESSMENT.NO_DATA.TITLE')}
              </Body3>
              <NoDataMessageContainer>
                <Body4 color="eerieBlack">
                  {t('COMMON.SELF_ASSESSMENT.NO_DATA.MESSAGE')}
                </Body4>
              </NoDataMessageContainer>
            </NoResultContainer>
            {!isViewer && (
              <CreateNewMyAuditButtonContainer>
                <ButtonLarge
                  title={t(
                    'COMMON.SELF_ASSESSMENT.BUTTON.CREATE_SELF_ASSESSMENT'
                  )}
                  onClick={() => {
                    removeItem('parentAssessment');
                    removeItem('selfAssessments');
                    removeItem('disabledCategories');
                    removeItem('selfAssessmentslocal');
                    navigate('/selfAssessment/selectDepartments');
                  }}
                />
              </CreateNewMyAuditButtonContainer>
            )}
          </>
        )}
        {isLoading && selfAssessments.length === 0 && (
          <SelfAssessmentListSkeleton />
        )}
        {selfAssessments.length > 0 && (
          <ContentArea>
            <SortContainer>
              <Sort filters={sortingState} />
            </SortContainer>
            <InfiniteScroll
              height="calc(100vh - 340px)"
              dataLength={selfAssessments.length} // This is important to prevent unnecessary re-renders
              next={fetchData}
              hasMore={hasMore}
              loader={
                <LoaderContainer>
                  <LoadingContent layout="flex" />
                </LoaderContainer>
              }
            >
              {selfAssessments.length === 0 && <LoadingContent layout="flex" />}
              {selfAssessments &&
                selfAssessments.map((selfAssessment, index) => {
                  const lowerCaseText = text.toLowerCase();
                  if (
                    !(
                      selfAssessment.creator.userFirstName
                        .toLowerCase()
                        .includes(lowerCaseText) ||
                      selfAssessment.creator.userLastName
                        .toLowerCase()
                        .includes(lowerCaseText) ||
                      selfAssessment.auditor.userFirstName
                        .toLowerCase()
                        .includes(lowerCaseText) ||
                      selfAssessment.auditor.userLastName
                        .toLowerCase()
                        .includes(lowerCaseText)
                    )
                  ) {
                    return;
                  }
                  return (
                    <ExpandableCard
                      columns={accordionColumns(selfAssessment)}
                      subject={selfAssessment.proofReaderNotes}
                      key={`selfAssessment-${selfAssessment.id}-index-${index}`}
                      onExpand={() => handleCollapsible(selfAssessment)}
                      isLoading={loadingIndex === selfAssessment.id}
                      isCardOpen={openedCardIndex === selfAssessment.id}
                    >
                      <CardContentWrapper>
                        {loadingIndex === selfAssessment.id ? (
                          <LoadingContent layout="inline" />
                        ) : (
                          <>
                            {categoriesData && categoriesData.length > 0 && (
                              <>
                                <DepartmentContainer>
                                  <Headline5>
                                    {formatCategories(categoriesData)}
                                  </Headline5>
                                </DepartmentContainer>
                                {prevRadio === Event.sent &&
                                  selfAssessment.hasChild && (
                                    <Body5>
                                      {assessment &&
                                        assessment.childAuditor &&
                                        assessment.childAuditor.length &&
                                        assessment.childAuditor.map(
                                          (childAuditor, index) => (
                                            <>
                                              {convertName(
                                                childAuditor.userFirstName
                                              )}
                                              {` ${childAuditor.userLastName
                                                .charAt(0)
                                                .toUpperCase()} `}
                                              {index ==
                                                assessment.childAuditor.length - 1
                                                ? ''
                                                : ','}{' '}
                                            </>
                                          )
                                        )}
                                    </Body5>
                                  )}
                                <ActionButtonContainer>
                                  <Button
                                    title={t(
                                      'COMMON.SELF_ASSESSMENT.BUTTON.VIEW'
                                    )}
                                    onClick={() =>
                                      selfAssessmentSummary(
                                        selfAssessment.stayStart,
                                        selfAssessment.id,
                                        true,
                                        evnt,
                                        template,
                                        selfAssessment.stayStart
                                      )
                                    }
                                    outlined={true}
                                    inverted={true}
                                    backgroundColor={'oxfordBlue'}
                                    disabled={!selfAssessment.isDeleted}
                                  />
                                  <Button
                                    title={t(
                                      'COMMON.SELF_ASSESSMENT.BUTTON.SUMMARY'
                                    )}
                                    onClick={() =>
                                      viewSelfAssessment(
                                        categoriesData,
                                        selfAssessment
                                      )
                                    }
                                    disabled={!selfAssessment.isDeleted}
                                  />
                                  <Button
                                    title={t(
                                      'COMMON.SELF_ASSESSMENT.BUTTON.COMPLETE'
                                    )}
                                    disabled={
                                      selfAssessment.isDeleted ||
                                      !selfAssessment.isAuditor
                                    }
                                    onClick={() => {
                                      navigate('/editSelfAssessment', {
                                        state: {
                                          assess: assessment,
                                          assessmentId:
                                            selfAssessment.isAuditor &&
                                              selfAssessment.childId
                                              ? selfAssessment.childId
                                              : selfAssessment.id,
                                          parentId:
                                            selfAssessment.isAuditor &&
                                              selfAssessment.childId
                                              ? selfAssessment.id
                                              : selfAssessment.parentAssessmentId,
                                          categoryId: categoriesData[0].uuid,
                                          template: filterTemplateData(
                                            template
                                          ),
                                        },
                                      });
                                    }}
                                    backgroundColor={'verdigris'}
                                  />
                                  <Button
                                    title={t(
                                      'COMMON.SELF_ASSESSMENT.BUTTON.DELETE'
                                    )}
                                    backgroundColor={'rustyRed'}
                                    onClick={() => {
                                      setItemToDelete(selfAssessment.id);
                                      setShowDeleteModal(true);
                                    }}
                                    disabled={
                                      selfAssessment.creator.id !==
                                      userData.user.id
                                    }
                                  />
                                </ActionButtonContainer>
                              </>
                            )}
                          </>
                        )}
                      </CardContentWrapper>
                    </ExpandableCard>
                  );
                })}
            </InfiniteScroll>
          </ContentArea>
        )}
      </SelfAssessmentsContainer>
      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          handleModalClose={() => setShowDeleteModal(false)}
        >
          <ModalHeader>
            <Headline3>
              {t(
                'COMMON.SELF_ASSESSMENT.MESSAGES.DELETE_SELF_ASSESSMENTS_CONFIRMATION'
              )}
            </Headline3>
          </ModalHeader>
          <ModalContent>
            <Body4>
              {t(
                'COMMON.SELF_ASSESSMENT.MESSAGES.PERMANENTLY_DELETE_SELF_ASSESSMENT_NOTE'
              )}
            </Body4>
          </ModalContent>
          <ButtonBlockColumn>
            <ButtonLarge
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.KEEP_ASSESSMENT')}
              onClick={() => setShowDeleteModal(false)}
            />
            <ButtonLarge
              title={t('COMMON.BOTTOM_SHEET.DELETE')}
              onClick={handleDeleteSelfAssessment}
              backgroundColor="rustyRed"
            />
            <ButtonLarge
              title={t('COMMON.OUTSIDE.BUTTONS.CLOSE')}
              onClick={() => setShowDeleteModal(false)}
              outlined={true}
              inverted={true}
            />
          </ButtonBlockColumn>
        </Modal>
      )}
      <BottomSheet
        isOpen={showFilterModal}
        onClose={() => {
          setShowFilterModal(false);
          setAssignees(
            filterInitialisation ? filterInitialisation.assignees : []
          );
          setUser({
            id: userData.user.id,
            text: `${userData.user.userFirstName} ${userData.user.userLastName}`,
          });
        }}
        title={t('COMMON.MY_AUDIT.BUTTON.FILTER')}
      >
        <FilterModalContent>
          <FilterModalHeaderContainer>
            <StatusRadioReceivedWrapper checked={radioCheck === 'received'}>
              <RadioButton
                checked={radioCheck === 'received'}
                label={t('COMMON.MY_ACTIONS.SELECTOR.RECEIVED')}
                onClick={() => {
                  setRadioCheck('received');
                  setAssessedTag(false);
                }}
              />
            </StatusRadioReceivedWrapper>
            <StatusRadioCreatedByWrapper checked={radioCheck === 'sent'}>
              <RadioButton
                checked={radioCheck === 'sent'}
                label={t('COMMON.MY_ACTIONS.SELECTOR.CREATED_BY')}
                onClick={() => {
                  setRadioCheck('sent');
                  setAssessedTag(false);
                }}
              />
            </StatusRadioCreatedByWrapper>
            <StatusRadioAssessedWrapper checked={assessedTag}>
              <RadioButton
                checked={assessedTag}
                label={t('COMMON.MY_ACTIONS.SELECTOR.TAGGED')}
                onClick={() => {
                  setRadioCheck('tagged');
                  setAssessedTag(true);
                }}
              />
            </StatusRadioAssessedWrapper>
          </FilterModalHeaderContainer>
          <FilterInputContainer>
            <DisabledSearchBoxContainer>
              <IconContainer>
                <SearchIcon />
              </IconContainer>
              <SearchFieldInput disabled={true} value={user && user.text} />
            </DisabledSearchBoxContainer>
          </FilterInputContainer>
          <FilterInputContainer>
            <SearchBoxContainsUsers
              callBackSelectedOptions={handleContainsUsersSearchValue}
              clearFilter={clearFilter}
              selectedUsers={assignees}
              selectedAndOrOption={andOrOption}
            />
          </FilterInputContainer>

          <FilterLabelContainer>
            <Body5 color="eerieBlack">
              {t('COMMON.MY_AUDIT.GENERIC_FIELDS.FIND_DEPARTMENT')}
            </Body5>
          </FilterLabelContainer>
          <FilterInputContainer>
            <DropdownSingle
              isSearchable={false}
              defaultOption={
                selectedFocusArea &&
                  focusAreaOptions &&
                  focusAreaOptions.categories &&
                  focusAreaOptions.categories.some(
                    (category) =>
                      category.sourceTemplateCategoryId.toString() ===
                      selectedFocusArea
                  )
                  ? {
                    label: focusAreaOptions.categories.find(
                      ({ sourceTemplateCategoryId }) =>
                        sourceTemplateCategoryId.toString() ===
                        selectedFocusArea
                    ).value,
                    value: selectedFocusArea,
                  }
                  : null
              }
              callback={(event) => setSelectedFocusArea(event.value)}
              options={
                focusAreaOptions &&
                focusAreaOptions.categories &&
                focusAreaOptions.categories.map((category, index) => {
                  return {
                    label: category.value,
                    value: category.sourceTemplateCategoryId.toString(),
                    category: category.categoryType,
                  };
                })
              }
            />
          </FilterInputContainer>
          <FilterLabelContainer>
            <Body5 color="eerieBlack">
              {t('COMMON.MY_AUDIT.TITLES.DATE_RANGE')}
            </Body5>
          </FilterLabelContainer>
          <SelfAssessmentDatePickerContainer>
            <InputContainer>
              <DatePicker
                className={`self-assessment-filter-date-picker`}
                popperClassName="date-picker-popper"
                dateFormat="dd-MM-yyyy"
                onFocus={(e) => e.target.blur()}
                placeholderText="Start Date"
                selected={startDate}
                onKeyDown={(e) => {
                  if (isNaN(e.target.value) || e.target.value !== '/') {
                    e.preventDefault();
                  }
                }}
                onChange={(selectedDate) => {
                  if (selectedDate) {
                    setStartDate(selectedDate);
                  }
                }}
                maxDate={endDate}
              />
              <CalendarIconContainer>
                {startDate ? (
                  <CloseCircleRed onClick={() => setStartDate(undefined)} />
                ) : (
                  <Calendar />
                )}
              </CalendarIconContainer>
            </InputContainer>
            <InputContainer>
              <DatePicker
                className={`self-assessment-filter-date-picker`}
                popperClassName="date-picker-popper"
                dateFormat="dd-MM-yyyy"
                minDate={startDate}
                onFocus={(e) => e.target.blur()}
                placeholderText="End Date"
                selected={endDate}
                onChange={(selectedDate) => {
                  if (selectedDate) {
                    setEndDate(selectedDate);
                  }
                }}
              />
              <CalendarIconContainer>
                {endDate ? (
                  <CloseCircleRed onClick={() => setEndDate(undefined)} />
                ) : (
                  <Calendar />
                )}
              </CalendarIconContainer>
            </InputContainer>
          </SelfAssessmentDatePickerContainer>
          <FilterLabelContainer>
            <Body5 color="eerieBlack">
              {t('COMMON.MY_AUDIT.TITLES.STATUS')}
            </Body5>
          </FilterLabelContainer>
          <FilterStatusContainer>
            {selfAssessmentStatus ? (
              <DropdownSingle
                options={statusOptions}
                defaultOption={getSelectedSelfAssessmentStatus(
                  selfAssessmentStatus
                )}
                menuPlacement="top"
                callback={(event) => {
                  setSelfAssessmentStatus(event.value);
                }}
              />
            ) : (
              <DropdownSingle
                defaultOption={null}
                options={statusOptions}
                menuPlacement="top"
                callback={(event) => {
                  setSelfAssessmentStatus(event.value);
                }}
              />
            )}
          </FilterStatusContainer>
          <BottomSheetButtonSpacing>
            <ButtonLarge
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.SHOW_RESULT')}
              onClick={() => {
                setPageNumber(1);
                setSelectedSelfAssessmentId(undefined);
                setLoadingIndex(null);
                setOpenedCardIndex(null);
                if ((endDate && startDate) || (!endDate && !startDate)) {
                  if (user) {
                    setPrevRadio(radioCheck);
                    setShowFilterModal(!showFilterModal);
                    setApplyFilter(!applyFilter);
                    setSelfAssessments([]);
                  } else {
                    showErrorMessage('Please select a Valid user');
                  }
                } else {
                  showErrorMessage('Please select a valid Date Range');
                }
              }}
            />
            <ButtonLarge
              outlined={true}
              inverted={true}
              backgroundColor={'eerieBlack'}
              title={t('COMMON.MY_AUDIT.BUTTON.CLEAR_FILTERS')}
              onClick={() => clear()}
            />
          </BottomSheetButtonSpacing>
        </FilterModalContent>
      </BottomSheet>
      {showSwitchHotelModal && notificationHotelData && (
        <SwitchHotelModal
          showSwitchHotelModal={showSwitchHotelModal}
          handleModalClose={() => setShowSwitchHotelModal(false)}
          switchHotelHandler={switchHotelHandler}
          notificationHotelData={notificationHotelData}
        />
      )}
    </>
  );
};

export default SelfAssessments;
